import React from 'react';
export var ignoreAttribute = 'data-editor-content-component';

/**
 * Wraps content components in a data attribute to ignore
 */
export var contentComponentClickWrapper = function contentComponentClickWrapper(reactComponents) {
  return /*#__PURE__*/React.createElement("div", {
    "data-editor-content-component": 'true'
  }, reactComponents);
};